import { trackMetric } from './Telemetry.js'

/**
 * Organization management. The auto org bundle reflects the acting user's org; for actions that
 * target a specific org (settings/member edits) pass `org_id` in `extra` to record the edited org.
 */
export type OrgAction = 'member_invited' | 'member_role_changed' | 'settings_updated'

export const trackOrgAction = (action: OrgAction, extra: Record<string, string | number | boolean> = {}): void => {
  trackMetric('org.action', { action, ...extra })
}
